document.addEventListener("DOMContentLoaded", function () {
  const sliderEl = document.querySelector(".collection-slider");
  if (!sliderEl) return;

  const slidesPerView = parseInt(sliderEl.dataset.columns) || 3;
  const showArrows = sliderEl.dataset.showArrows === "true";
  const totalSlides = sliderEl.querySelectorAll(".swiper-slide").length;
  const loopEnabled = totalSlides > slidesPerView;

  new Swiper(sliderEl, {
    loop: loopEnabled,
    slidesPerView: slidesPerView,
    spaceBetween: 10,
    navigation: showArrows ? {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    } : false,
    breakpoints: {
      0: { slidesPerView: 1.3 },
      768: { slidesPerView: slidesPerView }
    }
  });
});
